package anjuros.development.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import anjuros.development.components.RoomCard
import anjuros.development.components.RoomZoomView
import anjuros.development.components.SectionTitle
import anjuros.development.modules.Room
import anjuros.development.modules.Section
import anjuros.development.modules.Theme
import anjuros.development.util.Constants
import anjuros.development.util.Constants.SECTION_WIDTH
import anjuros.development.util.ObserverViewportEntered
import anjuros.development.util.ObserverViewportEntered2
import anjuros.development.util.RoomColumnWidthStyle
import anjuros.development.util.SmallSectionWidthStyle
import anjuros.development.util.rememberOrientation
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.px

@Composable
fun RoomsSection() {
    Box(
        modifier = Modifier
            .id(Section.Rooms.id)
            .margin(topBottom = 40.px)
            .maxWidth(SECTION_WIDTH.px),
        contentAlignment = Alignment.Center
    ) {
        RoomContent()
    }
}

@Composable
fun RoomContent(){
    var animatedMargin = remember { mutableStateOf(80.px) }
    var animatedOpacity = remember { mutableStateOf(0.0f) }
    var clickedRoom  by remember { mutableStateOf<Room?>(null)}
    var imageZoomedIndex  by remember { mutableStateOf(0)}

    val isLandscape  =  rememberOrientation()

    ObserverViewportEntered(
        sectionId = Section.Rooms.id,
        distanceFromTop = 400.0
    ) {
        animatedMargin.value = 30.px
        animatedOpacity.value = 1.0f
    }

    Column(
        modifier = Modifier
            .fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = SmallSectionWidthStyle.toModifier()
                .margin(bottom = 25.px),
            section = Section.Rooms,
            alignment = Alignment.CenterHorizontally
        )

        SimpleGrid(numColumns = numColumns(base = if(isLandscape.value)2 else 1, md = 2, lg = 3),
            modifier = Modifier
                .fillMaxWidth(),
            ) {
            Room.entries.forEach { room ->
                Box(
                    modifier = Modifier
                        .fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    RoomCard(
                        room,
                        animatedOpacity = animatedOpacity.value,
                        animatedMargin = animatedMargin.value,
                        onClick = {
                            clickedRoom = room
                        })

                    if(clickedRoom!=null && clickedRoom== room) {
                        clickedRoom?.zoomImages?.let { selectedRoom->
                            RoomZoomView(
                                modifier = Modifier
                                    .displayUntil(Breakpoint.LG),
                                selectedRoom[imageZoomedIndex],
                                onLeftClicked = {
                                    imageZoomedIndex--
                                    if (imageZoomedIndex == -1) {
                                        imageZoomedIndex = selectedRoom.size-1
                                    }
                                },
                                onRightClicked = {
                                    imageZoomedIndex++
                                    if (imageZoomedIndex >= selectedRoom.size) {
                                        imageZoomedIndex = 0
                                    }
                                },
                                onExitClicked = {
                                    clickedRoom = null
                                })
                        }
                    }
                }
            }
        }
    }

    if(clickedRoom!=null) {
        clickedRoom?.zoomImages?.let { selectedRoom->
            RoomZoomView(
                modifier = Modifier
                    .displayIfAtLeast(Breakpoint.LG),
                selectedRoom[imageZoomedIndex],
                onLeftClicked = {
                    imageZoomedIndex--
                    if (imageZoomedIndex == -1) {
                        imageZoomedIndex = selectedRoom.size-1
                    }
                },
                onRightClicked = {
                    imageZoomedIndex++
                    if (imageZoomedIndex >= selectedRoom.size) {
                        imageZoomedIndex = 0
                    }
                },
                onExitClicked = {
                    clickedRoom = null
                })
        }
    }
}